import React, { useState } from "react";
import "./PlansSection.css";
import { FaCheck, FaTimes, FaTrophy } from "react-icons/fa";
import { NavLink } from "react-router-dom";

const plans = [
  {
    name: "Basic Plan",
    priceInr: 4281,
    priceUsd: 49, // approx
    note: "per month after 6-month free trial",
    tag: "STARTER",
    color: "#10B981",
    features: [
      { label: "Complete shipping & returns", included: true },
      { label: "Secure warehousing", included: true },
      { label: "Tax compliance", included: true },
      { label: "Marketplace setup", included: false },
      { label: "Custom Marketing", included: false },
      { label: "Sales Guarantees", included: false }
    ],
    button: "Start Free Trial",
    link: "/SellInIndiaForm"
  },
  {
    name: "Standard Plan",
    priceInr: 87296,
    priceUsd: 999,
    note: "per month after trial review",
    tag: "POPULAR",
    color: "#6366F1",
    features: [
      { label: "Everything in BASIC, plus:", included: true },
      { label: "Marketplace Setup (Amazon, Flipkart, etc.)", included: true },
      { label: "Product Audit & Review", included: true },
      { label: "Custom Marketing Strategy", included: true },
      { label: "Dedicated Support", included: true },
      { label: "$1 Million Annual Sales Guarantee", included: true, isSpecial: true }
    ],
    button: "🔒 Unlock After Review Your Basic Plan Perforamnce",
    link: "/standard-review"
  },
  {
    name: "Enterprise Plan",
    priceInr: 873747,
    priceUsd: 9999,
    note: "per month after review",
    tag: "ENTERPRISE",
    color: "#F59E0B",
    features: [
      { label: "Everything in STANDARD, plus:", included: true },
      { label: "Retail Market Setup (DMart, Reliance Smart)", included: true },
      { label: "Franchise Distribution Support", included: true },
      { label: "Dedicated Account Manager", included: true },
      { label: "Priority Support", included: true },
      { label: "10 Million Annual Sales Guarantee", included: true, isSpecial: true }
    ],
    button: "🔒 Unlock After Review Your Standard Plan Perforamnce",
    link: "/enterprise-review"
  }
];

const PlansSection = () => {
  const [currency, setCurrency] = useState("INR"); // default INR

  return (
    <section className="plans-section">
      <div className="plans-header">
        <h2>Choose Your Growth Path</h2>
        <p>Flexible plans that scale with your success</p>

        {/* Currency Toggle */}
        <div className="currency-toggle">
          <button
            className={currency === "INR" ? "active" : ""}
            onClick={() => setCurrency("INR")}
          >
            ₹ INR
          </button>
          <button
            className={currency === "USD" ? "active" : ""}
            onClick={() => setCurrency("USD")}
          >
            $ USD
          </button>
        </div>
      </div>

      <div className="plans-container">
        {plans.map((plan, index) => (
          <div
            className="plan-card"
            key={index}
            style={{ borderColor: plan.color }}
          >
            <div className="tag" style={{ backgroundColor: plan.color }}>
              {plan.tag}
            </div>
            <h3>{plan.name}</h3>

            {/* Price dynamically */}
            <p className="price" style={{ color: plan.color }}>
              {currency === "INR"
                ? `₹${plan.priceInr}`
                : `$${plan.priceUsd}`}
            </p>

            <p className="note">{plan.note}</p>
            <ul className="features">
              {plan.features.map((feature, i) => (
                <li key={i} className={feature.included ? "included" : "excluded"}>
                  {feature.isSpecial ? (
                    <FaTrophy />
                  ) : feature.included ? (
                    <FaCheck />
                  ) : (
                    <FaTimes />
                  )}{" "}
                  {feature.label}
                </li>
              ))}
            </ul>

            <NavLink to={plan.link}>
              <button
                className="plan-button"
                style={{ backgroundColor: plan.color }}
              >
                {plan.button}
              </button>
            </NavLink>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PlansSection;
